<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Types de produits</h1>
                    <p>Gestion des commandes</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxshop.producttype.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un type</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxshop.producttype.import')" @click="importFile()">
                  <icon name="upload-cloud-01"/>
                  <span>Importer</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :tabs="tabsFilter" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>
                            <div></div>
                            <div class="picture"></div>
                            <div>
                              <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'SKU', value:'sku'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div><span>Statut</span></div>
                            <div class="actions"></div>
                            <div></div>
                        </div>
                    </div>

                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxshop.producttype.view', item.id )">
                            <div></div>
                          <!-- @todo Change this icon -->
                            <div class="picture no-radius">
                                <figure>
                                    <i v-if="!item.picture" class="icon icon-icon_tags"></i>
                                    <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                                </figure>
                            </div>
                            <div data-field="name"><strong class="highlight">{{ item.name }}</strong></div>
                            <div data-field="slug" style="white-space: nowrap;">{{ item.slug }}</div>
                            <div><published v-model="item.published"></published></div>
                            <div class="actions">
                                <ul>
                                    <li v-if="$aclInterfaceValidator('weeboxshop.producttype.delete',item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                    <li v-if="$aclInterfaceValidator('weeboxshop.producttype.update',item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>

            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>

    import ProductTypeService from './ProductTypeService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                tabsFilter: []
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return ProductTypeService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/type/Index.vue